import { type FC } from "react"
import styled from "styled-components"

import { type PersonalizedThinEvent } from "@forento/core/models/event"
import { toPriceString } from "@forento/core/utilities/currency"

import { containerClasses, Tag, tagsClasses, titleClasses } from "./shared"

const Event: FC<{ event: PersonalizedThinEvent }> = ({ event }) => (
	<div className={containerClasses}>
		<h3 className={titleClasses}>{event.title}</h3>
		<div className={tagsClasses}>
			{event.response === "attending" ? (
				<ResponseTag $response="attending">Attending</ResponseTag>
			) : event.response === "interested" ? (
				<ResponseTag $response="interested">Interested</ResponseTag>
			) : event.response === "not-interested" ? (
				<ResponseTag $response="not-interested">Not interested</ResponseTag>
			) : (
				<ResponseTag $response="not-responded">Not responded</ResponseTag>
			)}
			<Tag color="green">
				{event.price !== null
					? toPriceString(event.price)
					: event.membershipIds.length > 0
						? "Membership"
						: "Free"}
			</Tag>
		</div>
	</div>
)

const ResponseTag = styled.div<{ $response: "attending" | "interested" | "not-interested" | "not-responded" }>`
	font-weight: 600;
	font-size: 12px;
	line-height: 1;
	color: ${props => {
		switch (props.$response) {
			case "attending":
				return "#059669"
			case "interested":
				return "#7c3aed"
			case "not-interested":
				return "#dc2626"
			case "not-responded":
				return "#6b7280"
		}
	}};
	background-color: ${props => {
		switch (props.$response) {
			case "attending":
				return "#d1fae5"
			case "interested":
				return "#ede9fe"
			case "not-interested":
				return "#fee2e2"
			case "not-responded":
				return "#f3f4f6"
		}
	}};
	border-radius: 12px;
	padding: 6px 12px;
`

export default Event
